module.exports = __webpack_public_path__ + "static/media/test_ww_search.c720fd73.csv";